import { reactive } from 'vue';

/* eslint-disable */
export function useDelivery() {
    const state = reactive({
        productCode: null,
        type: null,
        modal: { isOpen: false, type: null },
        texts: {
            title: '',
            period: '',
            cost: '',
        },
        list: {} as any,
    });

    const setProductCode = (productCode: string) => {
        state.productCode = productCode as unknown as typeof state.productCode;
    };

    const setList = (list: any[]) => {
        state.list = list as unknown as typeof state.list;
    };

    /** Для надписи о бесплатной доставке учитываем только ПВЗ в выбранном городе. */
    const getFreeDeliveryVariant = () => {
        return state.list?.outpoint?.filter.filter((el: any) => {
            return el.uid === 'DeliverySystemMagnitPost' && el.isInCity;
        })[0];
    };

    const getCheapDeliveryVariant = () => {
        let cheapVariant = null;
        let price = Number.MAX_SAFE_INTEGER;

        if (state.list.outpoint) {
            state.list.outpoint.filter.forEach((variant: any) => {
                if (variant.minPrice < price) {
                    cheapVariant = variant;
                    price = variant.minPrice;
                }
            });
        }

        if (state.list.courier !== undefined) {
            state.list.courier.filter.forEach((variant: any) => {
                if (variant.minPrice < price) {
                    cheapVariant = variant;
                    price = variant.minPrice;
                }
            });
        }

        return cheapVariant;
    };

    const getFastDeliveryVariant = () => {
        let fastVariant = null;
        let period = Number.MAX_SAFE_INTEGER;

        if (state.list.outpoint) {
            state.list.outpoint.filter.forEach((variant: any) => {
                if (variant.minDate < period) {
                    fastVariant = variant;
                    period = variant.minDate;
                }
            });
        }

        if (state.list.courier !== undefined) {
            state.list.courier.filter.forEach((variant: any) => {
                if (variant.minDate < period) {
                    fastVariant = variant;
                    period = variant.minDate;
                }
            });
        }

        return fastVariant;
    };

    const initDeliveryInCatalog = () => {
        const deliveryBlocks = document.querySelectorAll(
            '.product-delivery-block'
        );

        /* eslint-disable */
        const deliveryDate: string = window?.config?.user?.deliveryDate || '';
        const freeDeliveryDate: string =
            window?.config?.user?.freeDeliveryDate || '';

        deliveryBlocks.forEach((product) => {
            const fastedBlock = product.querySelector(
                '.delivery-variant--fast .delivery-variant__period'
            );

            const cheapedBlock = product.querySelector(
                '.delivery-variant--cheap .delivery-variant__period'
            );

            const freeBlock = product.querySelector(
                '.delivery-variant--free-valid'
            );

            const cheapBlock = product.querySelector(
                '.delivery-variant--cheap'
            );

            if (!fastedBlock) {
                return;
            }

            const hasFreeDelivery = freeBlock && freeDeliveryDate;

            if (hasFreeDelivery && cheapedBlock) {
                freeBlock.classList.add('d-flex');
                cheapedBlock.textContent = freeDeliveryDate;

                const freeDeliveryTitle = product.querySelector(
                    '.delivery-variant--free-valid .delivery-variant__title'
                );

                if (freeDeliveryTitle) {
                    freeDeliveryTitle.textContent = 'Бесплатная доставка';
                }

                fastedBlock.textContent = deliveryDate;

                document
                    .querySelectorAll('.badge--delivery')
                    .forEach((element) => {
                        element.classList.remove('d-none');
                    });
            } else {
                const fastDeliveryTitle = product.querySelector(
                    '.delivery-variant--fast .delivery-variant__title'
                );

                if (fastDeliveryTitle) {
                    fastDeliveryTitle.textContent = 'Доставка';
                }

                fastedBlock.textContent = deliveryDate;
                cheapBlock?.remove();
            }
        });
    };

    const initRegionDeliveryInCard = () => {
        const cheapVariant: any = getCheapDeliveryVariant();
        const fastVariant: any = getFastDeliveryVariant();
        const freeVariant: any = getFreeDeliveryVariant();

        const allFastElements = document.querySelectorAll(
            '.delivery-variant--fast'
        );
        const allCheapElements = document.querySelectorAll(
            '.delivery-variant--cheap'
        );

        allFastElements.forEach((element) => {
            if (!fastVariant) {
                element.remove();
                return;
            }
            let periodEl = element.querySelector('.delivery-variant__period');
            let costEl = element.querySelector('.delivery-variant__cost');

            if (periodEl && costEl) {
                periodEl.textContent = fastVariant.deliveryDate;
                costEl.textContent = `от ${fastVariant.minPrice} ₽`;
            }
        });

        allCheapElements.forEach((element) => {
            if (!cheapVariant) {
                element.remove();
                return;
            }
            let periodEl = element.querySelector('.delivery-variant__period');
            let costEl = element.querySelector('.delivery-variant__cost');
            let titleEl = element.querySelector('.delivery-variant__title');

            if (!periodEl || !costEl || !titleEl) {
                return;
            }

            const hasFreeDelivery =
                element.classList.contains('delivery-variant--free-valid') &&
                freeVariant;

            if (hasFreeDelivery) {
                periodEl.textContent = freeVariant.deliveryDate;
                costEl.textContent = '0 ₽';
                titleEl.textContent = 'Бесплатная доставка';
                element.classList.add('delivery-variant--free');
            } else {
                periodEl.textContent = cheapVariant.deliveryDate;
                costEl.textContent = `от ${cheapVariant.minPrice} ₽`;
            }

            /** Открываем лейблы с бесплатной доставкой */
            if (hasFreeDelivery) {
                document
                    .querySelectorAll('.badge--delivery')
                    .forEach((element) => {
                        element.classList.remove('d-none');
                    });
            }
        });
    };

    const initMskDeliveryInCard = () => {
        const ourVariant: any = state.list['ourpoint'];
        const fastVariant: any = state.list['fastDelivery'];

        const allFastElements = document.querySelectorAll(
            '.delivery-variant--fast'
        );

        if (!fastVariant && ourVariant) {
            allFastElements.forEach((element) => {
                let periodEl = element.querySelector(
                    '.delivery-variant__period'
                );
                let costEl = element.querySelector('.delivery-variant__cost');

                if (periodEl && costEl) {
                    periodEl.textContent = ourVariant.dateFrom;
                    costEl.textContent = '';
                }
            });
        }
    };

    return {
        setList,
        initRegionDeliveryInCard,
        initMskDeliveryInCard,
        initDeliveryInCatalog,
        setProductCode,
    };
}
